import { render, staticRenderFns } from "./BaseLayoutLogin.vue?vue&type=template&id=021ce030&scoped=true&"
import script from "./BaseLayoutLogin.vue?vue&type=script&lang=js&"
export * from "./BaseLayoutLogin.vue?vue&type=script&lang=js&"
import style0 from "./BaseLayoutLogin.vue?vue&type=style&index=0&id=021ce030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ce030",
  null
  
)

export default component.exports